// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@keyframes fadeIn-data-v-4933d047{0%{opacity:0;right:100%}1%{right:0}to{opacity:1;right:0}}.backdrop[data-v-4933d047]{align-items:center;background-color:rgba(0,0,0,.4);display:flex;height:100%;justify-content:center;opacity:0;position:fixed;right:100%;top:0;width:100%}.backdrop.open[data-v-4933d047]{animation:fadeIn-data-v-4933d047 .18s ease-out forwards;z-index:50}", ""]);
// Exports
module.exports = exports;
